import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  backdrop: {
    zIndex: 9999,
  },
});

function OverlayBackdrop({ open = false }) {
  const classes = useStyles();
  return <Backdrop className={classes.backdrop} open={open} />;
}

OverlayBackdrop.propTypes = {
  open: PropTypes.bool,
};

export default OverlayBackdrop;
